import { useState } from "react";
import { Button } from "../../components/ui";

export default function ResetUsageView({ target, onBack, onReset }) {
  const [busy, setBusy] = useState(false);

  async function handleReset() {
    setBusy(true);
    try {
      await onReset();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="tg-subpage">
      <div className="tg-subpage__header">
        <button className="tg-icon-btn" onClick={onBack} aria-label="Back">
          <BackIcon />
        </button>
        <div>
          <h2 style={{ fontSize: 17 }}>Reset usage</h2>
          <p style={{ fontSize: 12, color: "var(--slate)" }}>{target.llmLabel}</p>
        </div>
      </div>

      <div className="tg-subpage__body">
        <p style={{ fontSize: 13.5, color: "var(--slate)" }}>
          Resetting will set your visual usage to 0 tokens for this specific provider URL. This uses your
          profile&apos;s shared token pool for tracking.
        </p>
      </div>

      <div className="tg-subpage__footer">
        <Button fullWidth disabled={busy} onClick={handleReset}>
          {busy ? "Resetting…" : "Reset visual usage to 0"}
        </Button>
      </div>
    </div>
  );
}

function BackIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
